/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useRef, useEffect, useState } from 'react';
import { ElevationWrapper } from './styles/cpds-elevation-style';
import { CpdsElevationProps } from './typings';
import { themeStyleClass } from '../utils/cpds-utils';

const CpdsElevation: React.FC<CpdsElevationProps> = (props) => {
  const { domRef, exClasses, styleOverrides, themeTypography, children, ...rest } = props;
  const className = themeStyleClass('cpds-elevation', themeTypography, exClasses);

  const childRef = useRef(null);
  const [borderRadius, setHasBorderRadius] = useState('0px');

  useEffect(() => {
    if (childRef.current) {
      const style = window.getComputedStyle(childRef.current);
      const borderRadius = style.getPropertyValue('border-radius');
      setHasBorderRadius(borderRadius);
    }
  }, [children]);

  return (
    <ElevationWrapper
      className={className}
      ref={domRef}
      styleOverrides={styleOverrides}
      borderRadius={borderRadius}
      {...rest}
    >
      {React.cloneElement(children, { ref: childRef })}
    </ElevationWrapper>
  );
};

export default CpdsElevation;
